module.exports = __webpack_public_path__ + "static/media/icon-pause.511a50c3.svg";